import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiLock, FiArrowRight } = FiIcons;

const NoticeSection = () => {
  return (
    <div className="bg-yellow-50 border-t border-yellow-200 py-8">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-start space-x-3 mb-4">
            <SafeIcon icon={FiAlertTriangle} className="w-6 h-6 text-yellow-600 mt-1 flex-shrink-0" />
            <div className="text-gray-700">
              <p className="font-semibold text-lg mb-2">Notice:</p>
              <p className="mb-4">
                This website is created only for student practice. Account4Web experts have not fixed 
                technical issues here – so you can clearly see the real work level of students. Almost 
                80% of the website is perfect, and the remaining 20% is polished by experts in final projects.
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3 mb-4">
            <SafeIcon icon={FiLock} className="w-6 h-6 text-green-600 mt-1 flex-shrink-0" />
            <div className="text-gray-700">
              <p className="mb-4">
                We never share any client website made under this offer with others – your project 
                privacy is 100% safe.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center">
            <a 
              href="https://projects.azaansuperpc.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 font-semibold"
            >
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              <span>Check Offer</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticeSection;